import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Link,
  Paper,
} from "@mui/material";
import VenueHeader from "../Venue/VenueHeader";
import FooterLogin from "src/layouts/compact/FooterLogin";

export default function AccountDeletionPolicy() {
  return (
    <>
      <VenueHeader />

      <Container maxWidth="md" sx={{ py: 4, mt: 12, mb: 6 }}>
        <Typography
          variant="h4"
          sx={{ color: "#F59B34", fontWeight: "bold", mb: 2 }}
        >
          Account and Data Deletion Policy
        </Typography>

        <Typography sx={{ mb: 3 }}>
          This page explains how you can request to delete your account and
          associated data from our app{" "}
          <strong>Egora - Discover,Reserve,Dine</strong>.
        </Typography>

        <Typography
          variant="h5"
          sx={{ color: "#2c3e50", fontWeight: "bold", mt: 3 }}
        >
          Steps to Request Account Deletion
        </Typography>

        <List sx={{ listStyleType: "decimal", pl: 3 }} component="ol">
          {[
            "Open the app on your device.",
            "Login to the account you wish to delete.",
            "Tap on the Menu icon (usually bottom right).",
            "Select Profile from the menu.",
            'Tap on the "Delete Account" button at the bottom.',
            "You will be prompted to confirm your identity by entering your password.",
            "After confirming, a request will be generated to delete your account and data.",
          ].map((step, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText primary={step} />
            </ListItem>
          ))}
        </List>

        <Paper
          elevation={0}
          sx={{
            backgroundColor: "#f8f8f8",
            borderLeft: "4px solid #F59B34",
            p: 2,
            my: 3,
          }}
        >
          <Typography>
            <strong>Important:</strong> You can recover your account within{" "}
            <strong>30 days</strong> of deletion request by simply logging in
            again. After 30 days, your data and account will be permanently
            deleted and cannot be recovered.
          </Typography>
        </Paper>

        <Typography
          variant="h5"
          sx={{ color: "#2c3e50", fontWeight: "bold", mt: 3 }}
        >
          What Data is Deleted?
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 3 }} component="ul">
          {[
            "Your personal account information (email,phone, name, profile, card details(if any)",
            "Any saved preferences, settings, and history",
          ].map((item, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>

        <Typography
          variant="h5"
          sx={{ color: "#2c3e50", fontWeight: "bold", mt: 3 }}
        >
          What Data is Retained?
        </Typography>
        <Typography sx={{ mb: 3 }}>
          We retain limited data for audit, security, or legal obligations where
          applicable (e.g., fraud prevention, abuse reports). This data is kept
          separate and cannot be used to identify you.
        </Typography>

        <Typography
          variant="h5"
          sx={{ color: "#2c3e50", fontWeight: "bold", mt: 3 }}
        >
          Need Help?
        </Typography>
        <Typography>
          If you're unable to access your account or have questions, you may
          contact our support team at{" "}
          <Link
            href="mailto:support@example.com"
            sx={{ color: "#F59B34", fontWeight: "bold" }}
          >
            info@egora.pk
          </Link>
          .
        </Typography>
      </Container>

      <FooterLogin />
    </>
  );
}
